module.exports = __webpack_public_path__ + "6cdc0b6eb63d41f79c9fe65460651ac4.png";